export const scientificMockData = [
  {
    id: 1,
    time: "08:30 - 10:00",
    session: "Plenary Session I",
    topic: "Advancements in Molecular Oncology & Genomic Medicine",
    hall: "Grand Ballroom A (1st Floor)",
    speakers: ["Dr. Alexander Wright", "Prof. Sarah Chen"],
    tags: ["Oncology", "Genomic", "Research"]
  },
  {
    id: 2,
    time: "10:30 - 12:00",
    session: "Symposium II",
    topic: "Digital Transformation in Healthcare 5.0: AI Integration",
    hall: "Melati Room (3rd Floor)",
    speakers: ["Dr. Linda Wijaya", "Ing. Roberto Mancini"],
    tags: ["HealthTech", "AI", "Digital"]
  },
  {
    id: 3,
    time: "13:30 - 15:00",
    session: "Workshop A",
    topic: "Hands-on: Modern Surgical Techniques in Cardiology",
    hall: "Laboratory Suite B",
    speakers: ["Dr. Aris Ahmad, Sp.BTKV"],
    tags: ["Surgery", "Cardiology", "Hands-on"]
  },
  {
    id: 4,
    time: "15:30 - 17:00",
    session: "Scientific Poster Session",
    topic: "Emerging Infectious Diseases in Tropical Regions",
    hall: "Exhibition Hall",
    speakers: ["Various Researchers"],
    tags: ["Infectious", "Poster", "Tropical"]
  }
];